module.exports = __webpack_public_path__ + "img/zgh.011dd8c1.svg";